import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatDate, formatEUR, FINANCEMENT_STATUSES } from "@/lib/api";
import { PageHeader, SelectField, EmptyState } from "@/components/ui-kit";
import StatusBadge from "@/components/StatusBadge";
import { Landmark, AlertTriangle } from "lucide-react";

const RELANCE_COLORS = ["", "bg-amber-50 text-amber-700 border-amber-200", "bg-orange-50 text-orange-700 border-orange-200", "bg-red-50 text-red-700 border-red-200"];

export default function Financements() {
  const [items, setItems] = useState([]);
  const [statutFilter, setStatutFilter] = useState("");
  const [showRelance, setShowRelance] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/dossiers").then((r) => {
      let arr = r.data;
      if (statutFilter) arr = arr.filter((d) => d.financement_statut === statutFilter);
      if (showRelance) arr = arr.filter((d) => (d.financement_relance_niveau || 0) >= 1);
      setItems(arr);
    }).finally(() => setLoading(false));
  }, [statutFilter, showRelance]);

  return (
    <div className="p-8" data-testid="financements-page">
      <PageHeader title="Financements" subtitle="Suivi bancaire clients" />
      <div className="bg-white rounded-sm border border-slate-200 mb-6 p-4 flex flex-wrap gap-3 items-end">
        <div className="min-w-[200px]">
          <SelectField testid="fin-filter" label="Statut financement" value={statutFilter} onChange={(e) => setStatutFilter(e.target.value)}
            options={[{ value: "", label: "Tous" }, ...FINANCEMENT_STATUSES]} />
        </div>
        <label className="flex items-center gap-2 pb-2 cursor-pointer">
          <input type="checkbox" checked={showRelance} onChange={(e) => setShowRelance(e.target.checked)} data-testid="fin-relance-toggle" />
          <span className="text-sm font-medium text-slate-700">Uniquement en relance</span>
        </label>
      </div>
      <div className="bg-white rounded-sm border border-slate-200 overflow-hidden">
        {loading ? <div className="p-10 text-center text-slate-500">Chargement…</div> :
          items.length === 0 ? <EmptyState icon={Landmark} title="Aucun financement à afficher" /> :
          <table className="w-full text-sm">
            <thead className="bg-slate-50"><tr>
              <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Client</th>
              <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Banque</th>
              <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Statut</th>
              <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Relance</th>
              <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Accord</th>
              <th className="text-right px-4 py-3 font-semibold uppercase text-xs">Montant</th>
            </tr></thead>
            <tbody>{items.map((d) => (
              <tr key={d.id} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-3"><Link to={`/dossiers/${d.id}`} className="font-semibold text-[#111111] hover:text-[#B8873A]">{d.client_prenom} {d.client_nom}</Link></td>
                <td className="px-4 py-3">{d.financement_banque || "—"}</td>
                <td className="px-4 py-3"><StatusBadge value={d.financement_statut} kind="financement" /></td>
                <td className="px-4 py-3">
                  {(d.financement_relance_niveau || 0) > 0 ? (
                    <span className={`badge-status ${RELANCE_COLORS[d.financement_relance_niveau] || ""}`}>
                      <AlertTriangle className="w-3 h-3 inline mr-1" /> Niveau {d.financement_relance_niveau}
                    </span>
                  ) : <span className="text-xs text-slate-400">—</span>}
                </td>
                <td className="px-4 py-3">{formatDate(d.financement_date_accord)}</td>
                <td className="px-4 py-3 text-right font-medium">{formatEUR(d.financement_montant)}</td>
              </tr>))}
            </tbody>
          </table>}
      </div>
    </div>
  );
}
